import AdminApp from '@/src/adminApp'
import AdminDashboard from '@/pages/admin/dashboard/index'
import AdminPostEdit from '@/pages/admin/posts/edit'
import AdminPicture from '@/pages/admin/pictures/index'
import AdminPosts from '@/pages/admin/posts/index'
import AdminTagGroups from '@/pages/admin/tagGroups/index'
import AdminTagGroupEdit from '@/pages/admin/tagGroups/edit'
import AdminTags from '@/pages/admin/tags/index'
import AdminTagsAssignment from '@/pages/admin/tagsAssignment'
import AdminWidgets from '@/pages/admin/widgets/index'
import AdminWidgetEdit from '@/pages/admin/widgets/edit'
import AdminWidgetNew from '@/pages/admin/widgets/new'
import AdminSettings from '@/pages/admin/settings/edit'
import AdminRssSettings from '@/pages/admin/rssSettings/edit'
import AdminAdminUsers from '@/pages/admin/adminUsers/index'
import AdminWriters from '@/pages/admin/writers/index'
import AdminWritersEdit from '@/pages/admin/writers/edit'
import AdminCharacters from '@/pages/admin/characters/index'
import AdminRegulationChecks from '@/pages/admin/regulationChecks/index'
import AdminRegulationCheckNew from '@/pages/admin/regulationChecks/new'
import AdminRegulationCheckEdit from '@/pages/admin/regulationChecks/edit'
import AdminContacts from '@/pages/admin/contacts/index'
import AdminContactsEdit from '@/pages/admin/contacts/edit'
import AdminOrderRegistrations from '@/pages/admin/orderRegistrations/index'
import AdminWriterMonthlyReports from '@/pages/admin/writerMonthlyReport/index'
import AdminMediaPages from '@/pages/admin/mediaPages/index'
import AdminPostLists from '@/pages/admin/postLists/index'
import AdminPostListEdit from '@/pages/admin/postLists/edit'
import AdminPasswords from '@/pages/admin/passwords'
import AdminProfiles from '@/pages/admin/profiles'
import AdminEmails from '@/pages/admin/emails'
import AdminProducts from '@/pages/admin/products/index'
import AdminProductNew from '@/pages/admin/products/new'
import AdminProductEdit from '@/pages/admin/products/edit'
import AdminProductsBulkRegistration from '@/pages/admin/productRegistrations/index'
import AdminExperts from '@/pages/admin/experts/index'
import AdminContributors from '@/pages/admin/contributors/index'
import AdminFeatures from '@/pages/admin/features/index'
import AdminDesigns from '@/pages/admin/designs/edit'
import AdminMediaRedirections from '@/pages/admin/mediaRedirections/index'
import AdminExhibitManagement from '@/pages/admin/exhibitManagement/index'
import AdminExhibitNew from '@/pages/admin/exhibits/new'
import AdminExhibitEdit from '@/pages/admin/exhibits/edit'
import AdminGallerySort from '@/pages/admin/gallerySorts/index'
import AdminOrders from '@/pages/admin/orders/index'
import AdminFooterLinks from '@/pages/admin/footerLinks/index'
import AdminUsersSidebar from '@/components/sidebars/admin/UsersSidebar'
import AdminPostsSidebar from '@/components/sidebars/admin/PostsSidebar'
import AdminSettingsSidebar from '@/components/sidebars/admin/SettingsSidebar'
import AdminHtmlPages from '@/pages/admin/htmlPages/index'
import AdminHtmlPageNew from '@/pages/admin/htmlPages/new'
import AdminHtmlPageEdit from '@/pages/admin/htmlPages/edit'
import AdminHtmlPageBasicEdit from '@/pages/admin/htmlPages/basic_edit'
import AdminSystemInformations from '@/pages/admin/systemInformations/index'
import AdminMailMagazineMembers from '@/pages/admin/mailMagazineMembers/index'
import AdminMailMagazineSettings from '@/pages/admin/mailMagazineSettings/edit'
import AdminGlossary from '@/pages/admin/glossary/index'
import AdminGlossaryPhraseNew from '@/pages/admin/glossary/new'
import AdminGlossaryPhraseEdit from '@/pages/admin/glossary/edit'

import store from '@/store'

const inMasterAccess = (to, from, next) => {
  if (window.origin === process.env.MASTER_ORIGIN) {
    return store.commit('errorPage/setForbidden', true)
  }
  next()
}

export const adminDashboard = 'adminDashboard'
export const adminUsers = 'adminUsers'
export const adminAdminUsers = 'adminAdminUsers'
export const adminWriters = 'adminWriters'
export const editWriter = 'editWriter'
export const adminExperts = 'adminExperts'
export const adminContributors = 'adminContributors'
export const adminPosts = 'adminPosts'
export const adminPostEdit = 'adminPostEdit'
export const adminPicture = 'adminPicture'
export const adminTagGroups = 'adminTagGroups'
export const adminTagGroupEdit = 'adminTagGroupEdit'
export const adminTags = 'adminTags'
export const adminTagsAssignment = 'AdminTagsAssignment'
export const adminWidgets = 'adminWidgets'
export const adminWidgetEdit = 'adminWidgetEdit'
export const adminWidgetNew = 'adminWidgetNew'
export const adminPostGroups = 'adminPostGroups'
export const adminPostGroupEdit = 'adminPostGroupEdit'
export const adminCharacters = 'adminCharacters'
export const adminRegulationChecks = 'adminRegulationChecks'
export const adminRegulationCheckNew = 'adminRegulationCheckNew'
export const adminRegulationCheckEdit = 'adminRegulationCheckEdit'
export const adminFeatures = 'adminFeatures'
export const adminOrderRegistrations = 'adminOrderRegistrations'
export const adminProducts = 'adminProducts'
export const adminProductNew = 'adminProductNew'
export const adminProductEdit = 'adminProductEdit'
export const adminProductsBulkRegistration = 'adminProductsBulkRegistration'
export const adminWriterMonthlyReport = 'adminWriterMonthlyReport'
export const adminOrders = 'adminOrders'
export const adminDesigns = 'adminDesigns'
export const adminSettings = 'adminSettings'
export const adminRssSettings = 'adminRssSettings'
export const adminContacts = 'adminContacts'
export const adminContactsEdit = 'adminContactsEdit'
export const adminMediaPages = 'adminMediaPages'
export const adminFooterLinks = 'adminFooterLinks'
export const adminMediaRedirections = 'adminMediaRedirections'
export const adminHtmlPages = 'adminHtmlPages'
export const adminHtmlPageNew = 'adminHtmlPageNew'
export const adminHtmlPageEdit = 'adminHtmlPageEdit'
export const adminHtmlPageBasicEdit = 'adminHtmlPageBasicEdit'
export const adminExhibitManagement = 'adminExhibitManagement'
export const adminExhibitNew = 'adminExhibitNew'
export const adminExhibitEdit = 'adminExhibitEdit'
export const adminGallerySort = 'adminGallerySort'
export const adminPasswords = 'adminPasswords'
export const adminProfiles = 'adminProfiles'
export const adminEmails = 'adminEmails'
export const adminSystemInformations = 'adminSystemInformations'
export const adminMailMagazineMember = 'adminMailMagazineMember'
export const adminMailMagazineSettings = 'adminMailMagazineSettings'
export const adminGlossary = 'adminGlossary'
export const adminGlossaryPhraseNew = 'adminGlossaryPhraseNew'
export const adminGlossaryPhraseEdit = 'adminGlossaryPhraseEdit'

export const pageNameMapper = [
  { searchValue: 'きじいちらん', jaName: '記事一覧', name: adminPosts },
  { searchValue: 'はっちゅういちらん', jaName: '発注一覧', name: adminOrders },
  {
    searchValue: 'れぎゅれーしょんちぇっくいちらん',
    jaName: 'レギュレーションチェック一覧',
    name: adminRegulationChecks
  },
  { searchValue: 'たぐいちらん', jaName: 'タグ一覧', name: adminTags },
  { searchValue: 'ほーむ', jaName: 'ホーム', name: adminDashboard },
  {
    searchValue: 'かんりしゃいちらん',
    jaName: '管理者一覧',
    name: adminAdminUsers
  },
  {
    searchValue: 'らいたーいちらん',
    jaName: 'ライター一覧',
    name: adminWriters
  },
  {
    searchValue: 'かんしゅうしゃいちらん',
    jaName: '監修者一覧',
    name: adminExperts
  },
  {
    searchValue: 'きこうしゃいちらん',
    jaName: '寄稿者一覧',
    name: adminContributors
  },
  { searchValue: 'かぞういちらん', jaName: '画像一覧', name: adminPicture },
  {
    searchValue: 'たぐぐるーぷいちらん',
    jaName: 'タググループ一覧',
    name: adminTagGroups
  },
  {
    searchValue: 'うぃじぇっといちらん',
    jaName: 'ウィジェット一覧',
    name: adminWidgets
  },
  {
    searchValue: 'うぃじぇっとしんきさくせい',
    jaName: 'ウィジェット新規作成',
    name: adminWidgetNew
  },
  {
    searchValue: 'きじぐるーぷ',
    jaName: '記事グループ',
    name: adminPostGroups
  },
  {
    searchValue: 'きゃらくたーせってい',
    jaName: 'キャラクター設定',
    name: adminCharacters
  },
  {
    searchValue: 'れぎゅれーしょんちぇっくしんきさくせい',
    jaName: 'レギュレーションチェック新規作成',
    name: adminRegulationCheckNew
  },
  {
    searchValue: 'とくしゅういちらん',
    jaName: '特集一覧',
    name: adminFeatures
  },
  {
    searchValue: 'いっかつはっちゅう',
    jaName: '一括発注',
    name: adminOrderRegistrations
  },
  {
    searchValue: 'しょうひんいちらん',
    jaName: '商品一覧',
    name: adminProducts
  },
  {
    searchValue: 'しょうひんしんきさくせい',
    jaName: '商品新規作成',
    name: adminProductNew
  },
  {
    searchValue: 'しょうひんいっかつとうろく',
    jaName: '商品一括登録',
    name: adminProductsBulkRegistration
  },
  {
    searchValue: 'らいたーげつじれぽーと',
    jaName: 'ライター月次レポート',
    name: adminWriterMonthlyReport
  },
  { searchValue: 'でざいん', jaName: 'デザイン', name: adminDesigns },
  { searchValue: 'さいとせってい', jaName: 'サイト設定', name: adminSettings },
  { searchValue: 'rssせってい', jaName: 'RSS設定', name: adminRssSettings },
  {
    searchValue: 'おといあわせいちらん',
    jaName: 'お問い合わせ一覧',
    name: adminContacts
  },
  {
    searchValue: 'おといあわせせってい',
    jaName: 'お問い合わせ設定',
    name: adminContactsEdit
  },
  { searchValue: 'こていぺーじ', jaName: '固定ページ', name: adminMediaPages },
  { searchValue: 'htmlぺーじ', jaName: 'HTMLページ', name: adminHtmlPages },
  {
    searchValue: 'ふったーりんく',
    jaName: 'フッターリンク',
    name: adminFooterLinks
  },
  {
    searchValue: 'りだいれくとせってい',
    jaName: 'リダイレクト設定',
    name: adminMediaRedirections
  },
  {
    searchValue: 'htmlぺーじしんきさくせい',
    jaName: 'HTMLページ新規作成',
    name: adminHtmlPageNew
  },
  {
    searchValue: 'ぎゃらりー',
    jaName: 'ギャラリー',
    name: adminExhibitManagement
  },
  {
    searchValue: 'ぎゃらりーしんきさくせい',
    jaName: 'ギャラリー新規作成',
    name: adminExhibitNew
  },
  {
    searchValue: 'ぎゃらりーならびかえ',
    jaName: 'ギャラリー並び替え',
    name: adminGallerySort
  },
  {
    searchValue: 'ぱすわーどへんこう',
    jaName: 'パスワード変更',
    name: adminPasswords
  },
  {
    searchValue: 'ぷろふぃーるへんしゅう',
    jaName: 'プロフィール編集',
    name: adminProfiles
  },
  {
    searchValue: 'めーるあどれすへんこう',
    jaName: 'メールアドレス変更',
    name: adminEmails
  },
  {
    searchValue: 'しすてむつうちいちらん',
    jaName: 'システム通知一覧',
    name: adminSystemInformations
  },
  {
    searchValue: 'めるまがかいいんいちらん',
    jaName: 'メルマガ会員一覧',
    name: adminMailMagazineMember
  },
  {
    searchValue: 'ようごしゅうへんしゅう',
    jaName: '用語集設定',
    name: adminGlossary
  }
]

export default {
  path: '/admin',
  component: AdminApp,
  meta: { requiresAuth: true },
  beforeEnter: inMasterAccess,
  children: [
    {
      path: '',
      name: adminDashboard,
      component: AdminDashboard
    },
    {
      path: 'users',
      name: adminUsers,
      redirect: 'users/admin_users'
    },
    {
      path: 'users/admin_users',
      name: adminAdminUsers,
      components: {
        default: AdminAdminUsers,
        subSidebar: AdminUsersSidebar
      }
    },
    {
      path: 'users/writers',
      name: adminWriters,
      components: {
        default: AdminWriters,
        subSidebar: AdminUsersSidebar
      }
    },
    {
      path: 'users/writers/:id/edit',
      name: editWriter,
      components: {
        default: AdminWritersEdit,
        subSidebar: AdminUsersSidebar
      }
    },
    {
      path: 'users/experts',
      name: adminExperts,
      components: {
        default: AdminExperts,
        subSidebar: AdminUsersSidebar
      }
    },
    {
      path: 'users/contributors',
      name: adminContributors,
      components: {
        default: AdminContributors,
        subSidebar: AdminUsersSidebar
      }
    },
    // 記事系
    {
      path: 'posts',
      name: adminPosts,
      components: {
        default: AdminPosts,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/:id/edit',
      name: adminPostEdit,
      component: AdminPostEdit
    },
    {
      path: 'posts/pictures',
      name: adminPicture,
      components: {
        default: AdminPicture,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/tag_groups',
      name: adminTagGroups,
      components: {
        default: AdminTagGroups,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/tag_groups/:tag_group_id/edit',
      name: adminTagGroupEdit,
      components: {
        default: AdminTagGroupEdit,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/tags',
      name: adminTags,
      components: {
        default: AdminTags,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/tags_assignment',
      name: adminTagsAssignment,
      components: {
        default: AdminTagsAssignment,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/widgets',
      name: adminWidgets,
      components: {
        default: AdminWidgets,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/widgets/:id/edit',
      name: adminWidgetEdit,
      component: AdminWidgetEdit
    },
    {
      path: 'posts/widgets/new',
      name: adminWidgetNew,
      component: AdminWidgetNew
    },
    {
      path: 'posts/post_groups',
      name: adminPostGroups,
      components: {
        default: AdminPostLists,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/post_groups/:group_role/edit',
      name: adminPostGroupEdit,
      components: {
        default: AdminPostListEdit,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/characters',
      name: adminCharacters,
      components: {
        default: AdminCharacters,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/regulation_checks',
      name: adminRegulationChecks,
      components: {
        default: AdminRegulationChecks,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/regulation_checks/new',
      name: adminRegulationCheckNew,
      component: AdminRegulationCheckNew
    },
    {
      path: 'posts/regulation_checks/:id/edit',
      name: adminRegulationCheckEdit,
      component: AdminRegulationCheckEdit
    },
    {
      path: 'posts/features',
      name: adminFeatures,
      components: {
        default: AdminFeatures,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'posts/order_registrations',
      name: adminOrderRegistrations,
      components: {
        default: AdminOrderRegistrations,
        subSidebar: AdminPostsSidebar
      }
    },
    {
      path: 'products',
      name: adminProducts,
      component: AdminProducts
    },
    {
      path: 'products/new',
      name: adminProductNew,
      component: AdminProductNew
    },
    {
      path: 'products/:id/edit',
      name: adminProductEdit,
      component: AdminProductEdit
    },
    {
      path: 'products/bulk_registration',
      name: adminProductsBulkRegistration,
      component: AdminProductsBulkRegistration
    },
    {
      path: 'users/writer_monthly_reports',
      name: adminWriterMonthlyReport,
      components: {
        default: AdminWriterMonthlyReports,
        subSidebar: AdminUsersSidebar
      }
    },
    {
      path: 'posts/orders',
      name: adminOrders,
      components: {
        default: AdminOrders,
        subSidebar: AdminPostsSidebar
      }
    },
    // デザイン
    {
      path: 'designs',
      name: adminDesigns,
      component: AdminDesigns
    },
    // 設定
    {
      path: 'settings',
      name: adminSettings,
      components: {
        default: AdminSettings,
        subSidebar: AdminSettingsSidebar
      }
    },
    {
      path: 'settings/rss_settings',
      name: adminRssSettings,
      components: {
        default: AdminRssSettings,
        subSidebar: AdminSettingsSidebar
      }
    },
    {
      path: 'settings/contacts',
      name: adminContacts,
      components: {
        default: AdminContacts,
        subSidebar: AdminSettingsSidebar
      }
    },
    {
      path: 'settings/contacts/edit',
      name: adminContactsEdit,
      components: {
        default: AdminContactsEdit,
        subSidebar: AdminSettingsSidebar
      }
    },
    {
      path: 'settings/media_pages',
      name: adminMediaPages,
      components: {
        default: AdminMediaPages,
        subSidebar: AdminSettingsSidebar
      }
    },
    {
      path: 'settings/footer_links',
      name: adminFooterLinks,
      components: {
        default: AdminFooterLinks,
        subSidebar: AdminSettingsSidebar
      }
    },
    {
      path: 'settings/media_redirections',
      name: adminMediaRedirections,
      components: {
        default: AdminMediaRedirections,
        subSidebar: AdminSettingsSidebar
      }
    },
    {
      path: 'settings/html_pages',
      name: adminHtmlPages,
      components: {
        default: AdminHtmlPages,
        subSidebar: AdminSettingsSidebar
      }
    },
    {
      path: 'settings/html_pages/new',
      name: adminHtmlPageNew,
      components: {
        default: AdminHtmlPageNew
      }
    },
    {
      path: 'settings/html_pages/:id/edit',
      name: adminHtmlPageEdit,
      components: {
        default: AdminHtmlPageEdit
      }
    },
    {
      path: 'settings/html_pages/:id/basic_edit',
      name: adminHtmlPageBasicEdit,
      components: {
        default: AdminHtmlPageBasicEdit
      }
    },
    {
      path: 'settings/exhibit_management',
      name: adminExhibitManagement,
      components: {
        default: AdminExhibitManagement,
        subSidebar: AdminSettingsSidebar
      }
    },
    {
      path: 'settings/exhibit/new',
      name: adminExhibitNew,
      components: {
        default: AdminExhibitNew
      }
    },
    {
      path: 'settings/exhibit/:id/edit',
      name: adminExhibitEdit,
      components: {
        default: AdminExhibitEdit
      }
    },
    {
      path: 'settings/gallery/sort',
      name: adminGallerySort,
      components: {
        default: AdminGallerySort
      }
    },
    {
      path: 'passwords',
      name: adminPasswords,
      component: AdminPasswords
    },
    {
      path: 'profiles',
      name: adminProfiles,
      component: AdminProfiles
    },
    {
      path: 'emails',
      name: adminEmails,
      component: AdminEmails
    },
    {
      path: 'system_informations',
      name: adminSystemInformations,
      component: AdminSystemInformations
    },
    {
      path: 'mail_magazine/members',
      name: adminMailMagazineMember,
      component: AdminMailMagazineMembers
    },
    {
      path: 'mail_magazine/setting/:service/edit',
      name: adminMailMagazineSettings,
      component: AdminMailMagazineSettings
    },
    {
      path: 'glossary',
      name: adminGlossary,
      component: AdminGlossary
    },
    {
      path: 'glossary_phrases/new',
      name: adminGlossaryPhraseNew,
      component: AdminGlossaryPhraseNew
    },
    {
      path: 'glossary_phrases/:id/edit',
      name: adminGlossaryPhraseEdit,
      component: AdminGlossaryPhraseEdit
    }
  ]
}
